// api.js - Servicio para conectar con PHP
class APIService {
  constructor(baseURL = '') {
    // Si no se proporciona baseURL, usar localhost con puerto por defecto
    if (!baseURL) {
      // Para desarrollo local - cambiar si tu API está en otro puerto
      const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      if (isDevelopment) {
        // En desarrollo, usar la misma ruta base del sitio + api
        const basePath = window.location.pathname.split('/').slice(0, -1).join('/');
        this.baseURL = `${window.location.protocol}//${window.location.host}${basePath}/api`;
      } else {
        this.baseURL = 'https://slategray-rhinoceros-572099.hostingersite.com/api';
      }
    } else {
      this.baseURL = baseURL;
    }
    this.token = localStorage.getItem('token');
    console.log('API Base URL:', this.baseURL);
    console.log('Window location:', window.location.href);
  }

  // Métodos de autenticación
  async login(email, password) {
    const response = await fetch(`${this.baseURL}/login.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });

    const data = await response.json();
    if (data.token) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      this.token = data.token;
    }
    return data;
  }

  async logout() {
    const response = await fetch(`${this.baseURL}/logout.php`, {
      method: 'POST',
      headers: this.getHeaders()
    });
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.token = null;
    return response.json();
  }

  // Métodos para afiliados
  async getAffiliates() {
    return this.fetchAPI('/affiliates.php', 'GET');
  }

  async getAfiliados() {
    const data = await this.fetchAPI('/affiliates.php', 'GET');
    return Array.isArray(data) ? data : data.affiliates || [];
  }

  async getAffiliado(id) {
    return this.fetchAPI(`/affiliates.php?action=get&id=${id}`, 'GET');
  }

  async createAfiliado(data) {
    return this.fetchAPI('/affiliates.php?action=create', 'POST', data);
  }

  async updateAfiliado(id, data) {
    return this.fetchAPI(`/affiliates.php?action=update&id=${id}`, 'POST', data);
  }

  async deleteAfiliado(id) {
    return this.fetchAPI(`/affiliates.php?action=delete&id=${id}`, 'DELETE');
  }


  // Métodos para usuarios
  async getUsers() {
    return this.fetchAPI('/users.php', 'GET');
  }

  async getCurrentUser() {
    return this.fetchAPI('/users.php?action=current-user', 'GET');
  }

  async createUser(data) {
    return this.fetchAPI('/users.php?action=create', 'POST', data);
  }

  async updateUser(data) {
    return this.fetchAPI('/users.php?action=update', 'PUT', data);
  }

  async deleteUser(id) {
    return this.fetchAPI('/users.php?action=delete', 'DELETE', { id });
  }

  // Métodos para sectores
  async getSectors() {
    return this.fetchAPI('/sectors.php', 'GET');
  }

  async getSectores() {
    return this.fetchAPI('/sectores.php', 'GET');
  }

  async createSector(data) {
    return this.fetchAPI('/sectors.php?action=create', 'POST', data);
  }

  async updateSector(data) {
    return this.fetchAPI('/sectors.php?action=update', 'PUT', data);
  }

  async deleteSector(id) {
    return this.fetchAPI('/sectors.php?action=delete', 'DELETE', { id });
  }

  // Métodos para dependientes
  async getDependents(affiliateId) {
    return this.fetchAPI(`/dependents.php?affiliate_id=${affiliateId}`, 'GET');
  }

  async getDependenciasByAfiliado(afiliadoId) {
    const data = await this.fetchAPI(`/dependencias.php?action=byAfiliado&afiliadoId=${afiliadoId}`, 'GET');
    return Array.isArray(data) ? data : [];
  }

  async createDependent(data) {
    return this.fetchAPI('/dependents.php?action=create', 'POST', data);
  }

  async createDependencia(data) {
    return this.fetchAPI('/dependencias.php?action=create', 'POST', data);
  }

  async updateDependent(data) {
    return this.fetchAPI('/dependents.php?action=update', 'PUT', data);
  }

  async updateDependencia(id, data) {
    return this.fetchAPI(`/dependencias.php?action=update&id=${id}`, 'PUT', data);
  }

  async deleteDependencia(id) {
    return this.fetchAPI(`/dependencias.php?action=delete&id=${id}`, 'DELETE');
  }

  async deleteDependent(id) {
    return this.fetchAPI('/dependents.php?action=delete', 'DELETE', { id });
  }

  // Métodos para pagos/cobros
  async getPayments(affiliateId = null) {
    try {
      const url = affiliateId 
        ? `/payments.php?affiliate_id=${affiliateId}`
        : '/payments.php';
      const data = await this.fetchAPI(url, 'GET');
      return Array.isArray(data?.payments) ? data.payments : Array.isArray(data) ? data : [];
    } catch (error) {
      console.warn('Error al obtener pagos, retornando array vacío:', error);
      return [];
    }
  }

  async createPayment(data) {
    return this.fetchAPI('/payments.php?action=create', 'POST', data);
  }

  async updatePayment(data) {
    return this.fetchAPI('/payments.php?action=update', 'PUT', data);
  }

  async deletePayment(id) {
    return this.fetchAPI('/payments.php?action=delete', 'DELETE', { id });
  }

  async getDailyPayments() {
    try {
      // Obtener pagos del día actual desde payments.php
      const url = '/payments.php?action=daily';
      const data = await this.fetchAPI(url, 'GET');
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.warn('Error al obtener pagos del día:', error);
      return [];
    }
  }

  // Métodos para cuadre de caja
  async openCuadre(cobradorId, sectorId = null) {
    return this.fetchAPI('/cuadre.php?action=open', 'POST', { 
      cobrador_id: cobradorId,
      sector_id: sectorId
    });
  }

  async getActiveCuadre(cobradorId, sectorId = null) {
    const url = sectorId 
      ? `/cuadre.php?action=get-active&cobrador_id=${cobradorId}&sector_id=${sectorId}`
      : `/cuadre.php?action=get-active&cobrador_id=${cobradorId}`;
    return this.fetchAPI(url, 'GET');
  }

  async addPaymentToCuadre(cuadreId, afiliadoId, monto, metodoPago = 'Efectivo') {
    return this.fetchAPI('/cuadre.php?action=add-payment', 'POST', {
      cuadre_id: cuadreId,
      afiliado_id: afiliadoId,
      monto: monto,
      metodo_pago: metodoPago
    });
  }

  async getCuadreDetails(cuadreId) {
    return this.fetchAPI(`/cuadre.php?action=get-details&cuadre_id=${cuadreId}`, 'GET');
  }

  async closeCuadre(cuadreId) {
    return this.fetchAPI('/cuadre.php?action=close', 'POST', { cuadre_id: cuadreId });
  }

  async getCuadreHistory(limit = 10, offset = 0) {
    return this.fetchAPI(`/cuadre.php?action=history&limit=${limit}&offset=${offset}`, 'GET');
  }

  // Método helper para todas las peticiones
  async fetchAPI(endpoint, method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getHeaders()
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, options);
      
      if (response.status === 401) {
        // Token expirado
        localStorage.removeItem('token');
        window.location.href = '/login';
      }

      const text = await response.text();
      
      // Intentar parsear como JSON
      try {
        return JSON.parse(text);
      } catch (e) {
        console.error('Error al parsear JSON. Respuesta:', text);
        throw new Error(`Respuesta inválida del servidor: ${text.substring(0, 100)}`);
      }
    } catch (error) {
      console.error('Error en API:', error);
      throw error;
    }
  }

  // Métodos para notificaciones
  async getNotifications() {
    return this.fetchAPI('/notifications.php', 'GET');
  }

  async checkAndCreateNotifications() {
    return this.fetchAPI('/notifications.php?action=check-delays', 'POST', {});
  }

  async markNotificationAsRead(notificationId) {
    return this.fetchAPI('/notifications.php?action=mark-read', 'POST', { id: notificationId });
  }

  // Helper para headers
  getHeaders() {
    const token = localStorage.getItem('token'); // Obtener token actual cada vez
    const headers = {
      'Content-Type': 'application/json'
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  }
}

// Exportar instancia global - siempre usar el hosting
export const api = new APIService(
  'https://slategray-rhinoceros-572099.hostingersite.com/api'
);

export default APIService;
